<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header
        v-if="!everythingLoaded || requesting"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon class="load-rotate">hourglass_empty</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>
      <md-card-header v-else class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <h4 class="card-title">Basis gegevens</h4>
        <ValidationProvider
          name="firstName"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Voornaam</label>
            <md-input v-model="firstName" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="lastNamePrefix"
          rules="min:0|max:10"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Tussenvoegsel</label>
            <md-input v-model="lastNamePrefix" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="lastName"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Achternaam</label>
            <md-input v-model="lastName" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="email"
          rules="required|email"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>email</md-icon>
            <label>E-mailadres</label>
            <md-input
              v-model="email"
              type="email"
              autocomplete="off"
              data-1p-ignore
              data-lpignore="true"
              data-bwignore="true"
            ></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="password"
          rules="min:8"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>security</md-icon>
            <label>Wachtwoord</label>
            <md-input
              v-model="password"
              type="password"
              autocomplete="off"
              data-1p-ignore
              data-lpignore="true"
              data-bwignore="true"
            ></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="confirmPassword"
          rules="confirmed:password"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>security</md-icon>
            <label>Bevestig wachtwoord</label>
            <md-input
              v-model="confirmPassword"
              type="password"
              autocomplete="off"
              data-1p-ignore
              data-lpignore="true"
              data-bwignore="true"
            ></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <template v-if="!editingYourSelf">
          <h4 class="card-title">Rollen</h4>
          <template v-for="(role, index) in allRolesBooleans">
            <md-switch
              :key="index"
              v-model="allRolesBooleans[index]"
              :disabled="!canChangeRole(allRoles[index].name)"
            >
              {{ allRoles[index].label }}
            </md-switch>
          </template>

          <div class="form-category">* verplichte velden</div>
        </template>
        <template v-else>
          <h4 class="card-title">Rollen</h4>
          <div class="form-category">
            Het is niet mogelijk om de eigen rollen bij te werken.
          </div>
        </template>
      </md-card-content>

      <!-- begin field groups -->
      <template v-if="everythingLoaded">
        <md-card-content
          v-for="(fieldGroup, fieldGroupIndex) in fieldGroups"
          :key="fieldGroupIndex"
        >
          <h4 class="card-title">{{ fieldGroup.name }}</h4>
          <template
            v-for="(field, fieldIndex) in fieldsInGroup(fieldGroup['id'])"
          >
            <driver-edit-files
              v-if="fieldTypes[field['type_id']]['type'] === 'files'"
              :key="fieldIndex"
              :field-name="field.name"
              :field-id="field['id']"
              :content-types="
                fieldTypes[field['type_id']]['validation']['frontend'][
                  'content_type'
                ]
              "
            ></driver-edit-files>
            <template
              v-else-if="
                fieldTypes[field['type_id']]['type'] === 'gecoder' ||
                  fieldTypes[field['type_id']]['type'] === 'gecoder-map'
              "
            >
              <ValidationProvider
                :name="field.id"
                :rules="fieldTypes[field['type_id']]['validation']['frontend']"
                v-slot="{ passed, failed }"
                :key="fieldIndex"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>input</md-icon>
                  <label>{{ field.name }}</label>
                  <geocoder
                    v-model="fieldValues[field.id]['value']"
                    :value="fieldValues[field.id]['value']"
                  ></geocoder>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
              <span
                :key="fieldIndex + 'map'"
                class="container-map-click-location"
              >
                <map-click-location
                  v-if="
                    fieldValues[field.id]['value']['lat'] &&
                      fieldValues[field.id]['value']['lng']
                  "
                  style="height: 250px; width: 100%;"
                  v-model="fieldValues[field.id]['value']"
                  :value="fieldValues[field.id]['value']"
                  marker="marker-driver.png"
                ></map-click-location>
              </span>
            </template>
            <ValidationProvider
              v-else
              :name="field.id"
              :rules="fieldTypes[field['type_id']]['validation']['frontend']"
              v-slot="{ passed, failed }"
              :key="fieldIndex"
            >
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'text'"
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-input
                  v-model="fieldValues[field.id]['value'][0]"
                  type="text"
                >
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'textarea'"
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-textarea
                  v-model="fieldValues[field.id]['value'][0]"
                ></md-textarea>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'date'"
                class="md-datepicker"
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label>{{ field.name }}</label>
                <md-datepicker
                  v-model="fieldValues[field.id]['value'][0]"
                  :name="field.id"
                  :id="field.id"
                  :md-model-type="String"
                  md-immediately
                  :disabled="true"
                />
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'select'"
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-select
                  v-model="fieldValues[field.id]['value'][0]"
                  :name="field.id"
                  :id="field.id"
                  required
                  :disabled="requesting"
                >
                  <md-option
                    v-for="(orderOption, index) in fieldTypes[field['type_id']][
                      'data'
                    ]['options']"
                    :value="orderOption['value']"
                    :key="index"
                    >{{ orderOption["label"] }}</md-option
                  >
                </md-select>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="
                  fieldTypes[field['type_id']]['type'] === 'select-multiple'
                "
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-select
                  v-model="fieldValues[field.id]['value']"
                  :name="field.id"
                  :id="field.id"
                  required
                  :disabled="requesting"
                  multiple
                >
                  <md-option
                    v-for="(orderOption, index) in fieldTypes[field['type_id']][
                      'data'
                    ]['options']"
                    :value="orderOption['value']"
                    :key="index"
                    >{{ orderOption["label"] }}</md-option
                  >
                </md-select>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </template>
        </md-card-content>
      </template>

      <md-card-actions>
        <md-button
          :disabled="requesting"
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
        >
          Terug
        </md-button>
        <md-button
          :disabled="!formTouched || requesting"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
        >
          Opslaan
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import Swal from "sweetalert2";
import Fuse from "fuse.js";
import DriverEditFiles from "../Drivers/DriverEditFiles.vue";
import geocoder from "../../../components/OpenStreetMap/InputGeocoder";
import MapClickLocation from "../../../components/OpenStreetMap/MapClickLocation.vue";

export default {
  components: {
    SlideYDownTransition,
    DriverEditFiles,
    geocoder,
    MapClickLocation
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      firstName: "",
      lastNamePrefix: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      fields: [],
      fieldGroups: [],
      fieldTypes: {},
      fieldValues: [],
      roles: [],
      allRoles: [],
      allRolesBooleans: [],
      touched: {
        firstName: false,
        lastNamePrefix: false,
        lastName: false,
        email: false,
        password: false,
        confirmPass: false,
        allRolesBooleans: false,
        fieldValues: false
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 2
        },
        lastNamePrefix: {
          required: false,
          min: 0,
          max: 10
        },
        lastName: {
          required: true,
          min: 2
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: false,
          min: 8
        },
        confirmPassword: {
          required: true,
          confirmed: "password"
        }
      },
      submitErrors: "",
      loaded: {
        user: false,
        groups: false,
        fields: false,
        types: false,
        roles: false
      }
    };
  },
  methods: {
    init() {
      this.$material.locale.dateFormat = "dd-MM-yyyy";
      this.$material.locale.firstDayOfAWeek = 1;
      this.$material.locale.days = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag"
      ];
      this.$material.locale.shortDays = [
        "Zon",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vri",
        "Zat"
      ];
      this.$material.locale.shorterDays = ["Z", "M", "D", "W", "D", "V", "Z"];
      this.$material.locale.months = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ];
      this.$material.locale.shortMonths = [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ];
      this.$material.locale.shorterMonths = [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
      ];

      this.loadFields();
      this.loadFieldTypes();
      if (this.$route.params.id !== undefined) {
        this.loadUser(this.$route.params.id);
        this.loadFieldGroups(this.$route.params.id);
        this.modelValidations.password.required = false;
        this.modelValidations.confirmPassword.required = false;
      } else {
        this.loadFieldGroups();
        this.firstName = "";
        this.lastNamePrefix = "";
        this.lastName = "";
        this.email = "";
        this.password = "";
        this.confirmPassword = "";
        this.roles = [];

        this.loaded.user = true;

        setTimeout(this.resetTouched, 100);

        this.modelValidations.password.required = true;
        this.modelValidations.confirmPassword.required = true;
      }
      this.loadUsersRoles();
    },
    formatDate(date) {
      if (typeof date !== "string" || date === "") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    validate() {
      let roles = [];

      if (this.touched.allRolesBooleans) {
        roles = [];
        for (var i in this.allRolesBooleans) {
          if (!this.allRolesBooleans[i]) {
            continue;
          }
          roles.push(this.allRoles[i].name);
        }
      } else {
        roles = undefined;
      }

      this.requesting = true;
      this.$http
        .post(
          this.$apiBaseUrl +
            "users/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            firstName: this.firstName,
            lastNamePrefix: this.lastNamePrefix,
            lastName: this.lastName,
            email: this.email,
            password: this.password !== "" ? this.password : undefined,
            confirmPassword:
              this.password !== "" ? this.confirmPassword : undefined,
            roles:
              this.password !== null && this.password !== undefined
                ? roles
                : undefined
          })
        )
        .then(
          response => {
            if (this.$route.params.id !== undefined) {
              this.saveFieldValues();
              this.loadFieldGroups(this.$route.params.id);
            } else {
              this.notifyVue(
                "Gebruiker succesvol opgeslagen",
                "check",
                "success",
                5000
              );
            }
            this.password = "";
            this.confirmPassword = "";
            setTimeout(this.resetTouched, 100);

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
            this.requesting = false;
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan gebruiker",
                "report_problem",
                "danger",
                0
              );
            }
            this.requesting = false;
          }
        );
    },
    saveFieldValues() {
      let values = [];

      for (let i in this.fieldValues) {
        let value = this.fieldValues[i]["value"];
        let isOfTypeDate = this.isValueOfTypeDate(i);

        values.push({
          field_id: this.fieldValues[i]["field_id"],
          value: isOfTypeDate ? [this.formatDateBack(value[0])] : value
        });
      }

      this.$http
        .post(
          this.$apiBaseUrl + "users/field/values/" + this.$route.params.id,
          Object.assign({
            values: values
          })
        )
        .then(
          response => {
            this.password = "";
            this.confirmPassword = "";

            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Gebruiker succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadUser(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "users/" + id).then(
        response => {
          this.firstName = response.data.user.firstName;
          this.lastNamePrefix = response.data.user.lastNamePrefix;
          this.lastName = response.data.user.lastName;
          this.email = response.data.user.email;
          this.password = "";
          this.confirmPassword = "";
          this.roles = response.data.user.roles;
          this.connectRolesToButtons();

          let fieldValues = {};
          for (let i in response.data.user.fieldValues) {
            fieldValues[response.data.user.fieldValues[i]["field_id"]] =
              response.data.user.fieldValues[i];
          }

          for (let i in this.fields) {
            if (fieldValues[this.fields[i]["id"]] !== undefined) {
              continue;
            }

            fieldValues[this.fields[i]["id"]] = {
              user_id: this.$route.params.id,
              field_id: this.fields[i]["id"],
              id: null,
              value: [""]
            };
          }
          this.fieldValues = fieldValues;

          if (this.loaded.fields === true && this.loaded.types === true) {
            this.reformatWhenLoaded();
          }

          setTimeout(this.resetTouched, 100);
          this.requesting = false;
          this.loaded.user = true;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van gebruikers", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadUsersRoles() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "users/roles").then(
        response => {
          this.allRolesBooleans = [];
          this.allRoles = this.sortCollection(
            response.data.roles,
            "name",
            "asc"
          );

          this.connectRolesToButtons();

          this.requesting = false;
          setTimeout(this.resetTouched, 100);
          this.loaded.roles = true;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van gebruikers", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadFields() {
      this.$http.get(this.$apiBaseUrl + "users/fields").then(
        response => {
          this.fields = response.data.fields;

          for (let i in this.fields) {
            if (this.fieldValues[this.fields[i]["id"]] !== undefined) {
              continue;
            }

            this.fieldValues[this.fields[i]["id"]] = {
              field_id: this.fields[i]["id"],
              id: "",
              value: [""]
            };
          }

          if (this.loaded.types === true && this.loaded.driver === true) {
            this.reformatWhenLoaded();
          }
          this.loaded.fields = true;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name", "fields", "order"],
            threshold: 0.3
          });
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadFieldGroups(id) {
      this.$http.get(this.$apiBaseUrl + "users/field/groups/" + id).then(
        response => {
          this.fieldGroups = response.data.fieldGroups;
          this.loaded.groups = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur veld groepen",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadFieldTypes() {
      this.$http.get(this.$apiBaseUrl + "users/field/types").then(
        response => {
          let fieldTypes = {};
          for (let i in response.data.fieldTypes) {
            fieldTypes[response.data.fieldTypes[i]["id"]] =
              response.data.fieldTypes[i];

            if (
              fieldTypes[response.data.fieldTypes[i]["id"]]["validation"][
                "frontend"
              ]["regex"] === undefined
            ) {
              continue;
            }

            fieldTypes[response.data.fieldTypes[i]["id"]]["validation"][
              "frontend"
            ]["regex"] = new RegExp(
              fieldTypes[response.data.fieldTypes[i]["id"]]["validation"][
                "frontend"
              ]["regex"]
            );
          }

          this.fieldTypes = fieldTypes;

          if (this.loaded.fields === true && this.loaded.driver === true) {
            this.reformatWhenLoaded();
          }
          this.loaded.types = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur veld typen",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    reformatWhenLoaded() {
      for (let f in this.fields) {
        if (this.fieldTypes[this.fields[f]["type_id"]]["type"] === "date") {
          this.fieldValues[this.fields[f]["id"]]["value"][0] = this.formatDate(
            this.fieldValues[this.fields[f]["id"]]["value"][0]
          );
        }
      }
    },
    isValueOfTypeDate(valueId) {
      for (let f in this.fields) {
        if (this.fields[f]["id"] !== valueId) {
          continue;
        }

        if (this.fieldTypes[this.fields[f]["type_id"]]["type"] === "date") {
          return true;
        }

        return false;
      }
    },
    connectRolesToButtons() {
      for (var i in this.allRoles) {
        this.allRolesBooleans[i] = this.inArray(
          this.roles,
          this.allRoles[i].name
        );
      }
    },
    resetTouched() {
      this.touched.firstName = false;
      this.touched.lastNamePrefix = false;
      this.touched.lastName = false;
      this.touched.email = false;
      this.touched.password = false;
      this.touched.confirmPass = false;
      this.touched.allRolesBooleans = false;
      this.touched.fieldValues = false;
    },
    showSwal() {
      Swal.fire({
        title: "Waarschuwing!",
        text: "Weet u zeker dat u de wijzigingen wilt negeren?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja, ga terug zonder op te slaan",
        cancelButtonText: "Annuleren",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$router.go(-1);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    canChangeRole(role) {
      let roles = localStorage.getItem("user_roles");
      roles = roles.split(",");

      if (roles.indexOf("admin") !== -1) {
        return true;
      }

      if (role.indexOf("manager_") !== 0) {
        return true;
      }

      return roles.indexOf(role) !== -1;
    },
    fieldsInGroup(groupId) {
      let data = [];

      for (let i in this.fields) {
        if (this.fields[i]["group_id"] !== groupId) {
          continue;
        }

        data.push(this.fields[i]);
      }

      return data;
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    firstName() {
      if (!this.requesting) {
        this.touched.firstName = true;
      }
    },
    lastNamePrefix() {
      if (!this.requesting) {
        this.touched.lastNamePrefix = true;
      }
    },
    lastName() {
      if (!this.requesting) {
        this.touched.lastName = true;
      }
    },
    email() {
      if (!this.requesting) {
        this.touched.email = true;
      }
    },
    password() {
      if (!this.requesting) {
        this.touched.password = true;
      }
    },
    confirmPassword() {
      if (!this.requesting) {
        this.touched.confirmPass = true;
      }
    },
    allRolesBooleans() {
      if (!this.requesting) {
        this.touched.allRolesBooleans = true;
      }
    },
    fieldValues: {
      handler: function(val, oldVal) {
        this.touched.fieldValues = true;
      },
      deep: true
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Gebruiker bewerken";
      }
      return "Gebruiker toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "person";
      }
      return "person_add";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    editingYourSelf: function() {
      return this.$route.params.id === localStorage.getItem("user_id");
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;
  &:after {
    bottom: 20px;
  }
}
</style>
